const getUrlWithoutTrailingSlash = url => {
  return url ? url.replace(/\/$/, "") : "";
};

module.exports = { getUrlWithoutTrailingSlash };
